import http from "../http-common";
/* eslint-disable */
class PaketWisataPertanyaanService {
  pertanyaanList(page, itemPerPage, keyword, paketWisataId) {
    return http.get(
      "/pib-paket-wisata-pertanyaan/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&paket_wisata_id=" +
        paketWisataId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    return http.post("/pib-paket-wisata-pertanyaan", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  update(data) {
    return http.put(`/pib-paket-wisata-pertanyaan/${data.id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  delete(id) {
    return http.delete(`/pib-paket-wisata-pertanyaan/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new PaketWisataPertanyaanService();
